import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreditCardPaymentComponent } from './creditcard-payment/creditcard-payment.component';
import { NotFoundComponent } from './error/not-found.component';
import { HomeComponent } from './home/home.component';
import { CreditCardPaymentDeclineComponent } from './creditcard-payment/creditcard-payment-decline.component';
import { CreditCardPaymentSuccessComponent } from './creditcard-payment/creditcard-payment-success.component';
import { InternalServerErrorComponent } from './error/internal-server-error.component';
import { ServiceUnavailableComponent } from './error/service-unavailable.component';
import { CardPaymentHostedTokenErrorComponent } from './error/card-payment-hosted-token-error.component';

const routes: Routes = [
  /*{ path: '', component: HomeComponent},
  { path: 'home', component: HomeComponent},*/
  { path: '', redirectTo: 'hosted/error/page-not-found', pathMatch: 'full'},
  //{ path: 'hosted/card/payment/decline', component: CreditCardPaymentDeclineComponent},
  //{ path: 'hosted/card/payment/success', component: CreditCardPaymentSuccessComponent},
  { path: 'hosted/card/payment/:hostedPaymentToken', component: CreditCardPaymentComponent},
  { path: 'hosted/error/internal-server-error', component: InternalServerErrorComponent},
  { path: 'hosted/error/card-payment-hosted', component: CardPaymentHostedTokenErrorComponent},
  { path: 'hosted/error/service-unavailable', component: ServiceUnavailableComponent},
  { path: 'hosted/error/page-not-found', component: NotFoundComponent},
  /*{ path: '**', component: NotFoundComponent}*/
  { path: '**', redirectTo: 'hosted/error/page-not-found'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}